const ru = {
  pleaseEnterUsername: "Пожалуйста, введите имя пользователя",
  cannotFriendYourself: "Вы не можете отправить запрос в друзья самому себе.",
  friendRequestSent: "Запрос в друзья отправлен!",
  failedToSendRequest: "Не удалось отправить запрос",
  linkCopied: "Ссылка скопирована в буфер обмена!",
  backToInvites: "Назад к приглашениям",
  sendFriendRequestByUsername: "Отправить запрос в друзья по имени пользователя",
  enterUsername: "Введите имя пользователя",
  send: "Отправить",
  yourInviteQrCode: "Ваш QR-код приглашения",
  inviteLink: "Ссылка-приглашение",
  scanQrOrUseLink: "Отсканируйте этот QR-код или используйте эту ссылку, чтобы отправить запрос в друзья",
  copyInviteLink: "Копировать ссылку приглашения",
  goToItem: "Перейти к элементу",
  verificationEmailSent: "Письмо для подтверждения отправлено! Проверьте папку «Входящие».",
  verificationEmailFailed: "Не удалось отправить письмо для подтверждения. Попробуйте ещё раз.",
  verifyYourEmail: "Подтвердите адрес электронной почты",
  verifyEmailInstructions: "Пожалуйста, подтвердите свой адрес электронной почты для доступа к аккаунту. Проверьте входящие сообщения на наличие ссылки подтверждения.",
  sending: "Отправка...",
  resendVerificationEmail: "Отправить письмо подтверждения повторно",
  login: "Войти",
  register: "Регистрация",
  home: "Главная",
  calendar: "Календарь",
  friends: "Друзья",
  profile: "Профиль",
  logout: "Выйти",
  loading: "Загрузка...",
  language: "Язык",
  calendarSelectPlaceSuggestion: "Пожалуйста, выберите место из предложенных вариантов, чтобы прикрепить координаты.",
  calendarSelectDateAndTime: "Пожалуйста, выберите дату и время.",
  calendarPositiveDuration: "Пожалуйста, укажите положительную продолжительность.",
  calendarFutureDateRequired: "Дата и время события должны быть в будущем.",
  calendarCreateEventFailed: "Не удалось создать событие. Попробуйте ещё раз.",
  cancel: "Отмена",
  createNewEvent: "Создать новое событие",
  week: "Неделя",
  month: "Месяц",
  eventTitle: "Название",
  date: "Дата",
  time: "Время",
  duration: "Продолжительность",
  endsAt: "Заканчивается в",
  place: "Место",
  searchForPlace: "Поиск места",
  placeSearchTip: "Совет: начните вводить текст и выберите результат, чтобы прикрепить координаты.",
  description: "Описание",
  createEvent: "Создать событие",
  today: "Сегодня",
  previousMonth: "Предыдущий месяц",
  nextMonth: "Следующий месяц",
  previous: "Назад",
  next: "Далее",
  mondayShort: "Пн",
  tuesdayShort: "Вт",
  wednesdayShort: "Ср",
  thursdayShort: "Чт",
  fridayShort: "Пт",
  saturdayShort: "Сб",
  sundayShort: "Вс",
  more: "ещё",
  mustRespondWillBeforeReposting: "Перед повторной публикацией необходимо выбрать «Приду»",
  event: "Событие",
  backToCalendar: "Назад к календарю",
  addToGoogleCalendar: "Добавить в Google Календарь",
  when: "Когда",
  where: "Где",
  openLocationInGoogleMaps: "Открыть место в Google Картах",
  hosts: "Организаторы",
  yourResponse: "Ваш ответ",
  currentResponse: "Текущий ответ",
  response_will: "Приду",
  response_might: "Возможно приду",
  response_wont: "Не приду",
  willRunIntoYou: "Зайду",
  mightDropBy: "Возможно зайду",
  wontCome: "Не приду",
  repostToMyFriends: "Поделиться с друзьями",
  responses: "Ответы",
  willAttend: "Придёт",
  reposted: "Поделился",
  mightAttend: "Возможно придёт",
  cancelEvent: "Отменить событие",
  cancellationEmailNoticeBefore: "Пользователи, подтвердившие участие,",
  cancellationEmailNoticeAfter: "получат письмо с уведомлением об отмене.",
  optionalCancellationMessage: "Необязательное сообщение для участников (максимум 1000 символов)",
  confirmCancelEvent: "Подтвердить отмену события",
  clear: "Очистить",
  confirmCancellation: "Подтвердить отмену",
  confirmCancellationMessage: "Вы уверены, что хотите отменить это событие? Подтверждённые участники будут уведомлены, а событие будет удалено.",
  eventCancelledNotified: "Событие отменено. Уведомлены:",
  attendees: "участники",
  failedToCancelEvent: "Не удалось отменить событие",
  back: "Назад",
  cancelled: "Отменено",
  ok: "ОК",
  forgotPassword: "Забыли пароль",
  email: "Электронная почта",
  passwordResetLinkSent: "Если аккаунт существует, ссылка для сброса пароля была отправлена.",
  passwordResetRequestFailed: "Не удалось запросить сброс пароля.",
  sendResetLink: "Отправить ссылку для сброса",
  addFriend: "Добавить друга",
  incomingRequests: "Входящие запросы",
  accept: "Принять",
  deny: "Отклонить",
  myFriends: "Мои друзья",
  noFriendsYet: "У вас пока нет друзей. Начните добавлять их!",
  seeProfile: "Посмотреть профиль",
  noEventsToRespondTo: "Нет событий, требующих ответа",
  allCaughtUp: "Вы в курсе всех событий. Загляните позже, чтобы увидеть новые события от друзей.",
  events: "События",
  unknown: "Неизвестно",
  noDescriptionProvided: "Описание не предоставлено.",
  will: "Да",
  maybe: "Возможно",
  wont: "Нет",
  userNotFound: "Пользователь не найден",
  friendRequestSentSuccessfully: "Запрос в друзья успешно отправлен!",
  friendInvitation: "Приглашение в друзья",
  sendFriendRequest: "Отправить запрос в друзья",
  loginToSendFriendRequest: "Войдите в систему, чтобы отправить запрос в друзья",
  chooseLanguage: "Выберите язык",
  invalidCredentials: "Неверные учётные данные. Попробуйте ещё раз.",
  username: "Имя пользователя",
  password: "Пароль",
  forgotPasswordQuestion: "Забыли пароль?",
  dontHaveAccount: "Нет аккаунта?",
  registerHere: "Зарегистрируйтесь здесь",
  invalidProfilePhotoType: "Недопустимый тип файла. Загрузите изображение JPEG, PNG, GIF или WebP.",
  invalidFileExtension: "Недопустимое расширение файла",
  allowedExtensions: "Разрешено",
  fileTooLarge: "Файл слишком большой",
  maximumFileSize: "Максимум",
  profilePhotoRemoved: "Фото профиля удалено.",
  failedToRemoveProfilePhoto: "Не удалось удалить фото профиля",
  profileUpdatedSuccessfully: "Профиль успешно обновлён!",
  failedToUpdateProfile: "Не удалось обновить профиль",
  privateEmailExplanation: "Только вы можете видеть свой адрес электронной почты, чтобы избежать нежелательных сообщений вне платформы",
  yourEmailIsPrivate: "Ваш адрес электронной почты скрыт.",
  profilePhoto: "Фото профиля",
  removePhoto: "Удалить фото",
  firstName: "Имя",
  lastName: "Фамилия",
  tellPeopleAboutYourself: "Расскажите о себе",
  whereToContactMe: "Как со мной связаться",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Сохранить",
  notSet: "Не указано",
  editProfile: "Редактировать профиль",
  imageToCrop: "Изображение для обрезки",
  zoom: "Масштаб",
  usePhoto: "Использовать фото",
  name: "Имя",
  whereToContact: "Контактная информация",
  removeFriendship: "Удалить из друзей",
  confirmRemoveFriend: "Подтвердить удаление друга",
  confirmRemoveFriendBefore: "Вы уверены, что хотите удалить",
  confirmRemoveFriendAfter: "из списка друзей?",
  friendRemoved: "Друг удалён.",
  failedToRemoveFriend: "Не удалось удалить друга.",
  confirmRemove: "Подтвердить удаление",
  error: "Ошибка",
  removed: "Удалено",
  passwordsDoNotMatch: "Пароли не совпадают",
  registrationFailed: "Не удалось зарегистрироваться. Попробуйте ещё раз.",
  confirmPassword: "Подтвердите пароль",
  alreadyHaveAccount: "Уже есть аккаунт?",
  loginHere: "Войти здесь",
  passwordResetSuccessfully: "Пароль успешно сброшен.",
  failedToResetPassword: "Не удалось сбросить пароль.",
  resetPassword: "Сбросить пароль",
  newPassword: "Новый пароль",
  confirmNewPassword: "Подтвердите новый пароль",
  setNewPassword: "Установить новый пароль",
  emailVerifiedSuccessfully: "Адрес электронной почты успешно подтверждён!",
  emailVerificationFailed: "Подтверждение не удалось. Ссылка может быть недействительной или устаревшей.",
  verifying: "Проверка...",
  verified: "Подтверждено!",
  redirectingToHome: "Перенаправление на главную страницу...",
  verificationFailed: "Ошибка подтверждения",
  goToHome: "Перейти на главную страницу",
  about: "О приложении",
  aboutConceptTitle: "Концепция",
  aboutCreatorIntroduction: "Привет, я Crypt0, скалолаз и создатель Run Into Me.",
  aboutCreatorStory: "Я создал этот сайт, потому что люблю общаться и между маршрутами постоянно разговариваю с другими скалолазами. В итоге у меня накопилось слишком много номеров, а организация встреч стала отнимать много свободного времени.",
  aboutPlanningProblem: "Мне надоело планировать занятия и писать каждому отдельно. Я хотел одновременно сообщать всем, когда и где буду лазать, без формального приглашения.",
  aboutDeveloperSolution: "Тогда я вспомнил, что я разработчик и могу сам создать решение.",
  aboutWelcome: "Добро пожаловать в Run Into Me: здесь можно сообщить друзьям об активности, к которой они могут присоединиться без обязательств.",
  aboutCallToAction: "Когда в следующий раз запланируете занятие, которое можно делать одному, но вместе веселее, опубликуйте его здесь!",
  aboutTutorialTitle: "Руководство",
  aboutCalendarCreateEvent: "На экране календаря также можно создать новое событие.",
  aboutEventColorsIntroduction: "Цвет события показывает ваш статус участия:",
  aboutColorGold: "Золотой",
  aboutColorGoldDescription: "Вы организатор этого события.",
  aboutColorGreen: "Зелёный",
  aboutColorGreenDescription: "Вы участвуете в этом событии.",
  aboutColorOrange: "Оранжевый",
  aboutColorOrangeDescription: "Вы ответили «возможно».",
  aboutColorBlue: "Синий",
  aboutColorBlueDescription: "Вы ещё не ответили.",
  aboutColorGray: "Серый",
  aboutColorGrayDescription: "Вы отклонили приглашение.",
  aboutCalendarEventDetails: "Нажмите событие, чтобы посмотреть подробности и ответить.",
  aboutFriendPageTitle: "Страница друзей",
  aboutFriendPageDescription: "Чтобы добавить друга, введите его имя пользователя или отправьте ссылку-приглашение / QR-код.",
  aboutHomePageTitle: "Главная страница",
  aboutHomePageDescription: "Просматривайте предстоящие события друзей и сообщайте, придёте ли вы.",
  aboutRepostScreenTitle: "Экран репоста",
  aboutGoogleCalendarDescription: "Добавьте событие в Google Календарь этой кнопкой.",
  aboutRepostDescription: "После подтверждения участия событие можно репостнуть для своих друзей.",
};

export default ru;